import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdicionaisEDescontosDetalharComponent } from './adicionais-e-descontos-detalhar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: AdicionaisEDescontosDetalharComponent}
  ])],
  exports: [RouterModule]
})
export class AdicionaisEDescontosDetalharRoutingModule { }
